import type { RequirementUploadReason } from '@/types/api';


export const DEFAULT_WORKFLOW_ID = 'six-role-pipeline-v1';
export const DEFAULT_WORKFLOW_LABEL =
  'Explorer → Architect → Coder → Reviewer → Tester → Documenter';

export const MAX_REQUIREMENT_FILE_BYTES = 5 * 1024 * 1024;

export function uploadReasonMessage(reason: RequirementUploadReason): string {
  switch (reason) {
    case 'unsupported_file':
      return 'Unsupported file — paste the requirement text instead.';
    case 'file_too_large':
      return 'File exceeds the 5 MB limit — paste the requirement text instead.';
    case 'extraction_failed':
      return 'Could not read this file — paste the requirement text instead.';
    case 'password_protected':
      return 'Password-protected files are not allowed — remove the password and re-upload.';
    case 'macro_enabled':
      return 'Macro-enabled files are not allowed — save without macros and re-upload.';
    case 'corrupted_file':
      return 'This file appears to be corrupted or unreadable.';
  }
}

export function combineRequirement(
  typed: string,
  extracted: string | null | ReadonlyArray<{ name: string; extracted_text: string }>
): string {
  const t = typed.trim();
  if (extracted == null) return t;
  if (typeof extracted === 'string') {
    const e = extracted.trim();
    if (t && e) return `${t}\n\n${e}`;
    return t || e;
  }
  const blocks = extracted
    .map((f) => ({ name: f.name.trim(), body: (f.extracted_text ?? '').trim() }))
    .filter((f) => f.body.length > 0)
    .map((f) => `--- ${f.name} ---\n${f.body}`);
  const merged = blocks.join('\n\n');
  if (t && merged) return `${t}\n\n${merged}`;
  return t || merged;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
